"use strict";

exports.__esModule = true;
exports.AdvancedMetricChartFields = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Catalogs = require("../../../Catalogs");
var _ChartControlsSelector = require("../../Echarts/FieldSelectors/ChartControlsSelector");
var _ChartItemsSelector = require("../../Echarts/FieldSelectors/ChartItems/ChartItemsSelector");
var _StatisticsCalculationsSelector = require("../../Echarts/FieldSelectors/StatisticsCalculationsSelector");
var _ChartTitleSelector = require("../../Echarts/FieldSelectors/ChartTitleSelector");
var _ToolBoxSelector = require("../../Echarts/FieldSelectors/ToolBoxSelector");
var _VisualMapSelector = require("../../Echarts/FieldSelectors/VisualMapSelector");
var _MultiFieldSelector = require("../../Recharts/Fields/MultiFieldSelector/MultiFieldSelector");
var _constants = require("../../Echarts/constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AdvancedMetricChartFields = exports.AdvancedMetricChartFields = function AdvancedMetricChartFields(props) {
  var elementEditor = props.elementEditor,
    path = props.path,
    element = props.element;
  var _element$props = element.props,
    title = _element$props.title,
    toolbox = _element$props.toolbox,
    statistics = _element$props.statistics,
    visualMap = _element$props.visualMap,
    chartItems = _element$props.chartItems,
    controls = _element$props.controls,
    selectedMetrics = _element$props.selectedMetrics;
  (0, _react.useEffect)(function () {
    if (!selectedMetrics || selectedMetrics.length === 0) {
      elementEditor.setProp(path, "selectedMetrics", [_Catalogs.metricDefinitions[0]]);
    }
  }, [selectedMetrics, elementEditor, path]);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_MultiFieldSelector.MultiFieldSelector, {
    "data-testid": "MetricsSelector",
    getKey: function getKey(input) {
      return input.name;
    },
    renderItemText: function renderItemText(input) {
      return input.label;
    },
    itemPredicate: function itemPredicate(query, _ref) {
      var label = _ref.label;
      return label.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    },
    selectedItems: selectedMetrics,
    onChange: function onChange(selectedValues) {
      return elementEditor.setProp(path, "selectedMetrics", selectedValues);
    },
    items: _Catalogs.metricDefinitions
  }), /*#__PURE__*/_react["default"].createElement(_ChartItemsSelector.ChartItemsSelector, {
    path: path,
    elementEditor: elementEditor,
    chartItems: chartItems,
    blacklistItems: [_constants.CHART_SCATTER]
  }), /*#__PURE__*/_react["default"].createElement(_ChartTitleSelector.ChartTitleSelector, {
    path: path,
    elementEditor: elementEditor,
    title: title
  }), /*#__PURE__*/_react["default"].createElement(_ToolBoxSelector.ToolBoxSelector, {
    path: path,
    elementEditor: elementEditor,
    toolbox: toolbox
  }), /*#__PURE__*/_react["default"].createElement(_StatisticsCalculationsSelector.StatisticsCalculationsSelector, {
    path: path,
    elementEditor: elementEditor,
    statistics: statistics
  }), /*#__PURE__*/_react["default"].createElement(_VisualMapSelector.VisualMapSelector, {
    path: path,
    elementEditor: elementEditor,
    visualMap: visualMap
  }), /*#__PURE__*/_react["default"].createElement(_ChartControlsSelector.ChartControlsSelector, {
    path: path,
    elementEditor: elementEditor,
    controls: controls
  }));
};